import fileItemComponent from './fileItem.component';
import './fileItem.scss';

const fileItemModule = angular.module('app.common.ertFileUploader.fileItem', [])
	.component('ertFileItem', fileItemComponent)
	.name;

export default fileItemModule;

